import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import contactUsService from '../../components/Services/contactUs.service';
import { toast } from 'react-toastify';
import { toastProperties } from '../../commons/Toast/Toaster';

const validationSchema = Yup.object().shape({
    name: Yup.string().required('required field'),
    email: Yup.string().required('required field'),
    phone: Yup.string().required('required field'),
    message: Yup.string().required('required field').min(50, 'Message should be minimum 50 characters').max(500, 'Message cannot exceed 500 characters')
})


const Contact = () => {
    const initialValues = {
        name: '',
        email: '',
        phone: '',
        message: '',
    }
    const numberInputOnWheelPreventChange = (e) => {
        // Prevent the input value change
        e.target.blur()
    
        // Prevent the page/container scrolling
        e.stopPropagation()
    
        // Refocus immediately, on the next tick (after the current function is done)
          setTimeout(() => {
            e.target.focus()
        }, 0)
    }
    return (
        <>
            <div className='container my-4'>
                <div className=' capacity-card'>
                    <div className=' capacity-card-body'>
                        <div className=' text-center'>
                            <h2>Contact Us</h2>
                            <div className=' fw-medium fs-6'>We're here to help! If you have any questions, suggestions, or inquiries, please feel free to get in touch with us using the form below.<br /> We'll do our best to respond to you as soon as possible.</div>
                        </div>
                        <Row className='m-0 m-md-5 my-4'>
                            <Col md={6} className='mb-5'>
                                <div className='contact-wrap mb-5'>
                                    <div>
                                        <i className='fa fa-home fa-3x fa-icon'></i>
                                    </div>
                                    <div>
                                        <h5 className='fw-bold'>Our Location</h5>
                                        <div>706, The Palm Spring Plaza, <br /> Golf Course Rd, DLF Phase 5, <br />Sector 54, Gurugram, Haryana 122009</div>
                                    </div>

                                </div>

                                <div className='contact-wrap mb-5'>
                                    <div>
                                        <i className='fa fa-headphones fa-3x fa-icon'></i>
                                    </div>
                                    <div>
                                        <h5 className='fw-bold'>Phone Number</h5>
                                        <div>(+91) 987 897 1111 / 987 654 0000 </div>
                                    </div>

                                </div>

                                <div className='contact-wrap'>
                                    <div>
                                        <i className='fa fa-envelope-o fa-3x fa-icon'></i>
                                    </div>
                                    <div>
                                        <h5 className='fw-bold'>Email Address</h5>
                                        <div>info@gna.energy / sales@gna.energy </div>
                                    </div>

                                </div>
                            </Col>
                            <Col md={6}>
                                <div className='contact-bg'>
                                    <Formik
                                        initialValues={initialValues}
                                        validationSchema={validationSchema}
                                        onSubmit={(values, { resetForm }) => {
                                            const reqBody = {
                                                "name": values.name,
                                                "email": values.email,
                                                "phone": values.phone,
                                                "message": values.message
                                            }
                                            const sendEmail = () => {
                                                contactUsService.sendEmail(reqBody).then((response) => {
                                                    if (response?.data?.code === 200) {
                                                        toast.success(response?.data?.message, toastProperties);
                                                        resetForm();
                                                    }
                                                }).catch(err => console.log(err))
                                            }
                                            sendEmail()
                                        }}

                                    >
                                        {({ isSubmitting, values, handleBlur,resetForm }) => (
                                            <Form>
                                                <div className='mb-3'>
                                                    <Field type="text" name="name" className="custom-input" placeholder="Your Name*" />
                                                    <ErrorMessage name='name' component="div" className='' />
                                                </div>

                                                <div className='mb-3'>
                                                    <Field type="text" name="email" className="custom-input" placeholder="Your Email*" />
                                                    <ErrorMessage name='email' component="div" className='' />
                                                </div>

                                                <div className='mb-3'>
                                                    <Field type="number" onWheel={numberInputOnWheelPreventChange} name="phone" className="custom-input" placeholder="Your Phone*" />
                                                    <ErrorMessage name='phone' component="div" className='' />
                                                </div>

                                                <div className='mb-3'>
                                                    <Field as="textarea" name="message" className="custom-input" placeholder="Your Message*" style={{ height: 'auto' }} />
                                                    <ErrorMessage name='message' component="div" className='' />
                                                </div>

                                                <div>
                                                    <button type='submit' className='btn btn-bookmark'>Send Message  <i className='fa fa-paper-plane'></i></button>
                                                </div>

                                            </Form>
                                        )}
                                    </Formik>
                                </div>
                            </Col>
                        </Row>

                    </div>
                </div>
            </div>
        </>
    );
}

export default Contact;
